import { money, pct } from "@/lib/api";

const Card = ({ label, value, sub, tone = "text-white", testId }) => (
  <div className="panel p-6" data-testid={testId}>
    <p className="eyebrow">{label}</p>
    <p className={`mt-3 font-mono text-2xl tracking-tight sm:text-3xl ${tone}`}>{value}</p>
    {sub && <p className="mt-2 text-xs text-slate-500">{sub}</p>}
  </div>
);

export default function SummaryCards({ p }) {
  const up = p.total_gain >= 0;
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <Card label="Total portfolio" value={money(p.total_value)} sub="Cash + holdings at current prices" testId="client-total-value-display" />
      <Card label="Cash balance" value={money(p.cash_balance)} tone="text-emerald-400" testId="client-cash-balance-display"
        sub={p.pending_withdrawals ? `${money(p.pending_withdrawals)} pending withdrawal` : "Available to invest"} />
      <Card label="Holdings value" value={money(p.holdings_value)} testId="client-holdings-value-display"
        sub={`Stocks ${money(p.stocks_value, 0)} · Property ${money(p.property_value, 0)}`} />
      <Card label="Total return" value={`${up ? "+" : ""}${money(p.total_gain)}`} tone={up ? "text-emerald-400" : "text-red-400"}
        sub={pct(p.total_gain_pct)} testId="client-total-return-display" />
    </div>
  );
}
